"use client";

import { useCallback, useContext, useMemo, useState } from "react";
import { IClientError } from "@finbackoffice/websocket-client";
import { IMessageResponse } from "@finbackoffice/clientbff-client";
import { AuthContext, useWebsocketUpdates } from "@finbackoffice/site-core";

export const useChat = (): IMessageResponse[] => {
    const { userToken } = useContext(AuthContext);
    const [data, setData] = useState<IMessageResponse[]>([]);

    const handleChatUpdates = useCallback((messages: IMessageResponse, error: IClientError) => {
        if (!error) {
            setData((state) => [...state, messages]);
        } else {
            console.error(error);
        }
    }, []);
    const params = useMemo(() => ({ token: userToken || "" }), [userToken]);

    useWebsocketUpdates("chat_message", handleChatUpdates, undefined, params);

    return data;
};
